export class FFLiabilies {
  accountLimit: number = 0;
  alimony: number = 0;
  cardsLimit: number = 0;
  guarantees: number = 0;
  installmentsFX: number = 0;
  installmentsPLN: number = 0;
  loansLiabilitiesSum: number = 0;
  mortgageLiabilitiesSum: number = 0;
}
